import { useState } from 'react'
import ReactGA from 'react-ga4'

export const Footer = () => {
    const [email, setEmail] = useState('')

    return (
        <footer className='relative bg-pbnavy py-12 md:pt-0 z-0 font-kiwi font-bold'>
            <div className='footer-content footer-wrapper'>
                <div className='socials-wrapper'>
                    <div className='socials'>
                        <div className=''>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social',
                                        label: `NIS Twitter`,
                                    })
                                }}
                                aria-label='Twitter'
                                href='https://twitter.com/nisamerica'
                                target='_blank'
                                rel='noreferrer'
                                data-label='Twitter'
                            >
                                <i className='fa-brands fa-x-twitter fa-2x md:fa-5x'></i>
                            </a>
                        </div>
                        <div>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social',
                                        label: `NIS Facebook`,
                                    })
                                }}
                                aria-label='Facebook'
                                href='https://www.facebook.com/NISAmericaInc/'
                                target='_blank'
                                rel='noreferrer'
                                className=''
                                data-label='Facebook'
                            >
                                <i className='fa-brands fa-facebook-f fa-2x'></i>
                            </a>
                        </div>
                        <div>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social',
                                        label: `NIS Instagram`,
                                    })
                                }}
                                aria-label='Instagram'
                                href='https://www.instagram.com/nisamerica/'
                                target='_blank'
                                rel='noreferrer'
                                className=''
                                data-label='Instagram'
                            >
                                <i className='fa-brands fa-instagram fa-2x'></i>
                            </a>
                        </div>
                        <div>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social',
                                        label: `NIS YouTube`,
                                    })
                                }}
                                aria-label='YouTube'
                                href='https://www.youtube.com/user/NISAmerica'
                                target='_blank'
                                rel='noreferrer'
                                className=''
                                data-label='YouTube'
                            >
                                <i className='fa-brands fa-youtube fa-2x'></i>
                            </a>
                        </div>
                        <div>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social',
                                        label: `NIS Twitch`,
                                    })
                                }}
                                aria-label='Twitch'
                                href='https://www.twitch.tv/nisamerica'
                                target='_blank'
                                rel='noreferrer'
                                className=''
                                data-label='Twitch'
                            >
                                <i className='fa-brands fa-twitch fa-2x '></i>
                            </a>
                        </div>
                        <div>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Social',
                                        label: `NIS Discord`,
                                    })
                                }}
                                aria-label='Discord'
                                href='https://discord.gg/nisa'
                                target='_blank'
                                rel='noreferrer'
                                className=''
                                data-label='Discord'
                            >
                                <i className='fa-brands fa-discord fa-2x'></i>
                            </a>
                        </div>
                    </div>
                    <div className='mailchimp md:basis-3/6 '>
                        <form
                            action='https://nisamerica.us11.list-manage.com/subscribe/post?u=e8fc423eff95099d1ffcc6009&amp;id=349f7d20f9'
                            method='post'
                            id='mc-embedded-subscribe-form'
                            name='mc-embedded-subscribe-form'
                            className='validate'
                            target='_blank'
                            noValidate=''
                            onSubmit="ga('send', 'event', 'Mailchimp', 'Submit', 'Signup Form');"
                        >
                            <div id='mc_embed_signup_scroll' className='mailchimp text-center '>
                                <div>
                                    <label htmlFor='mce-EMAIL' className='subscribe text-sm'>
                                        Abonnez-vous à notre liste de diffusion pour recevoir les dernières informations
                                        !
                                    </label>
                                </div>
                                <div className='bg-pbdarkorange rounded-lg'>
                                    <label className='subscribe-wrapper'>
                                        <input
                                            className=''
                                            type='email'
                                            placeholder='Votre Email'
                                            value={email}
                                            name='b_e8fc423eff95099d1ffcc6009_349f7d20f9'
                                            // name='EMAIL'
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                        <button
                                            className='px-8 '
                                            onClick={() => {
                                                ReactGA.event({
                                                    action: 'click',
                                                    event: 'link',
                                                    category: 'Socials',
                                                    label: `NIS Subscribe Newsletter`,
                                                })
                                            }}
                                        >
                                            Souscrire
                                        </button>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className='platforms'>
                    <div className='esrb flex flex-col justify-center'>
                        <div>
                            <img
                                className='border-2 mx-auto max-w-[80px] '
                                src={`https://nisamerica.com/public/assets/logo/pegi/pegi-12.jpeg`}
                                alt='pegi rating '
                            />{' '}
                        </div>
                        <p className='font-sans text-sub text-center mt-2'>
                            (Violence, <span className='whitespace-nowrap'>Langage Grossier</span>,{' '}
                            <span className='whitespace-nowrap'>Achats Intégrés</span>)
                        </p>
                    </div>
                    <div key={'ps4-5'}>
                        <img alt={'ps4-5'} src={`https://nisamerica.com/public/assets/logo/ps4-ps5.svg`} />
                    </div>
                    <div key={'nsw'}>
                        <img alt={'nsw'} src={`https://nisamerica.com/public/assets/logo/nsw.svg`} />
                    </div>
                    <div key={'steam'}>
                        <img alt={'steam'} src={`https://nisamerica.com/public/assets/logo/steam-white.svg`} />
                    </div>
                </div>

                <div className='developer pt-4'>
                    <div>
                        <img
                            style={{
                                width: '160px',
                                height: 'auto',
                            }}
                            alt={'Nipponichi software'}
                            src={`https://nisamerica.com/public/assets/logo/nisj.svg`}
                        />
                    </div>
                    <div>
                        <a href='https://nisamerica.com/'>
                            <img
                                style={{
                                    width: '210px',
                                    height: 'auto',
                                }}
                                alt='NIS logo'
                                src={`https://nisamerica.com/public/assets/logo/nis.svg`}
                            />
                        </a>{' '}
                    </div>{' '}
                </div>

                <div className='copyrights font-kiwi'>
                    <div className='text-sub text-white text-center border-t-0 border-stone-300 pb-20'>
                        <p className='mt-12'>
                            ©2025 Nippon Ichi Software, Inc. ©2025 NIS America, Inc. All rights reserved.
                        </p>
                        <p>Phantom Brave is a trademark or registered trademark of Nippon Ichi Software, Inc .</p>
                        <p>Nintendo Switch est une marque de Nintendo.</p>
                        <p>
                            ©2024 Sony Interactive Entertainment LLC. “<span className='font-sie'>1</span>“,
                            “PlayStation“, “<span className='font-sie'>5</span>“, “PS5“,{' '}
                            <span className='font-sie'>4</span>, “PS4“, “<span className='font-sie'>0</span>“ and “Play
                            Has No Limits“ are registered trademarks or trademarks of Sony Interactive Entertainment
                            Inc.
                        </p>
                        <p>
                            © 2024 Valve Corporation. Steam and the Steam logo are trademarks and/or registered
                            trademarks of Valve corporation in the US and/or other countries. All rights reserved.
                        </p>
                        <p className='mt-4'>Images tirées d'une version en développement.</p>
                    </div>{' '}
                </div>
            </div>
        </footer>
    )
}
